import React, {FC} from "react";

interface ModalProps {
    title: string;
    onHide: () => void;
}

const Modal: FC<ModalProps> = ({
                                   title,
                                   children,
                                   onHide
                               }) => {
    return (
        <div className="modal" onClick={onHide}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h6>{title}</h6>
                {children}
            </div>
        </div>
    );
};

export default Modal;